'use client';

import { useEffect, useRef } from 'react';
import { useTranslations } from 'next-intl';
import { Toast, useToast } from '@zillow/constellation-10';
import { useFeatureFlag } from '@/src/lib/feature-flags';
import * as styles from './mockInquiryStatus.styles';

export function MockInquiryToast() {
  const t = useTranslations('contactForm');
  const mockInquiryEnabled = useFeatureFlag('mock-inquiry');
  const { enqueueToast } = useToast();
  const hasEnqueuedRef = useRef(false);

  useEffect(() => {
    if (!mockInquiryEnabled) {
      hasEnqueuedRef.current = false;
      return;
    }

    if (hasEnqueuedRef.current) {
      return;
    }

    hasEnqueuedRef.current = true;
    enqueueToast(
      <Toast tone="info" role="status" data-testid="mock-inquiry-toast">
        <span className={styles.content}>
          <span className={styles.label}>{t('mockInquiryLabel')}</span>
          <span className={styles.message}>{t('mockInquiryActive')}</span>
        </span>
      </Toast>,
      { duration: 0 },
    );
  }, [enqueueToast, mockInquiryEnabled, t]);

  return null;
}
